import { useContext, createContext, useState } from "react";

const demandsContext = createContext();

export function ProvideDemands({ children }) {
  const demands = useProvideDemands();
  return (
    <demandsContext.Provider value={demands}>
      {children}
    </demandsContext.Provider>
  );
}

const useDemands = () => {
  return useContext(demandsContext);
};

export default useDemands;

const defaultState = {
  demands: 0,
};

function useProvideDemands() {
  const [demands, setDemandsData] = useState(defaultState);

  const setDemands = (data) => {
    setDemandsData({
      ...defaultState,
      ...data,
    });
  };

  return { demands, setDemands };
}
